const shared = {
  /** Tile Introduction Form */
  do_not_show_again: 'Do not show again',

  /** Tile Introduction Layout */
  students_respond_using: 'Students respond using',
  acadly_s_i_os_app: "Acadly's iOS app",
  acadly_s_android_app: "Acadly's Android app",
  acadly_s_web_app: "Acadly's Web app",
  responses_not_required: 'Responses not required',

  /** Tile Courses Form */
  select_a_course: 'Select a course',
  in_which_course_will_you_be_using_this_presentation: 'In which course will you be using this presentation',
  pin_this_course: 'Pin this course',

  /** Tile Classes Form */
  select_a_class: 'Select a class',
  in_which_lecture_will_you_be_using_this_presentation:
    'In which lecture will you be using this presentation',

  for_powerpoint: 'for PowerPoint',
  copy_to_lecture: 'Copy to lecture',
  course_code_colon_course_title: '{{courseCode}}: {{courseTitle}}',
} as const;

export default shared;
